import * as React from 'react';
import { FormField, InputAdornment, MaskedInput, Textarea } from '@cian/ui-kit';
import { TFormErrors, TFormValues } from '../../types';
import { PHONE_ADORNMENT } from '../../constants';
import { FormWrapper } from '../FormWrapper';
import { FormError } from '../FormError';

import styles from './styles.css';
import { FC } from 'react';

interface IConsultationForm {
  handleInputChange: <T extends keyof TFormValues>(inputName: T, value: TFormValues[T]) => void;
  values: TFormValues;
  errors?: TFormErrors | null;
  customerSupportPhone: string;
}

export const CallConsultationRequest: FC<IConsultationForm> = ({
  handleInputChange,
  errors,
  values,
  customerSupportPhone,
}) => {
  return (
    <FormWrapper title={`Позвоните на ${customerSupportPhone} или закажите обратный звонок`}>
      <div className={styles['consultation-form-phone']}>
        <FormField label="Ваш телефон" errorMessage={errors?.phone} required withoutMargin>
          <MaskedInput
            value={values.phone}
            onChange={value => handleInputChange('phone', value)}
            mask="(000) 000-00-00"
            size="M"
            leftAdornment={<InputAdornment>{PHONE_ADORNMENT}</InputAdornment>}
            data-testid="leave-contacts-modal-phone-input"
          />
        </FormField>
        <FormField label="Что хотите узнать?" errorMessage={errors?.question} required withoutMargin>
          <Textarea
            value={values.question}
            onChange={(_, value) => handleInputChange('question', value)}
            data-testid="leave-contacts-modal-question-input"
            minRows={4}
            maxRows={4}
          />
        </FormField>
      </div>
      {!!errors?.root && <FormError>{errors.root}</FormError>}
    </FormWrapper>
  );
};
